module.exports = __webpack_public_path__ + "e15145c538d82dd0418edf18ba21a8f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/upper_west_side_15.jpg
// module id = 291
// module chunks = 0